import writeXlsxFile from 'write-excel-file';
import moment from 'moment';
import { excelStyle } from '../../helpers/xlsxStyles';
import { Invoice } from '../../store/invoice/useGetInvoice';
import { Charge } from '../../store/invoice/useGetCharge';
import { BillToReceiveStatus } from './columnsInvoice';
import { months } from './columnsCharge';

const defaultStyle = {
    align: 'center',
    alignVertical: 'center',
    borderColor: '#727272',
    width: 25,
};

const { fontSize } = excelStyle;

export const schemaExcelTicket = [
    {
        column: 'ID Lojista',
        value: (ticket: Invoice): number => ticket.shopmanager.id,
        ...defaultStyle,
        width: 15,
    },
    {
        column: 'E-mail Lojista',
        value: (ticket: Invoice): string => ticket.shopmanager.user.email,
        ...defaultStyle,
    },
    {
        column: 'Data de emissão do boleto',
        value: (ticket: Invoice): string =>
            ticket?.issuedAt
                ? moment(ticket?.issuedAt).format('DD/MM/YYYY')
                : '',
        ...defaultStyle,
    },
    {
        column: 'Data de vencimento do boleto',
        value: (ticket: Invoice): string =>
            ticket?.dueDate ? moment(ticket?.dueDate).format('DD/MM/YYYY') : '',
        ...defaultStyle,
    },
    {
        column: 'Valor',
        value: (ticket: Invoice): string => (ticket.value / 100).toFixed(2),
        ...defaultStyle,
    },
    {
        column: 'Status do boleto',
        value: (ticket: Invoice): string =>
            BillToReceiveStatus[
                ticket.status as keyof typeof BillToReceiveStatus
            ],
        ...defaultStyle,
        width: 20,
    },
    {
        column: 'Código de barras copia e cola',
        value: (ticket: Invoice): string => ticket?.barcode,
        ...defaultStyle,
        width: 20,
    },
    {
        column: 'Baixar boleto em pdf',
        value: (): string => '-',
        ...defaultStyle,
        width: 20,
    },
];

export const schemaExcelInvoice = [
    {
        column: 'ID Lojista',
        value: (charge: Charge): number => charge.store.shopmanager_id,
        ...defaultStyle,
        width: 15,
    },
    {
        column: 'E-mail Lojista',
        value: (charge: Charge): string =>
            charge.store?.shopManager?.user?.email,
        ...defaultStyle,
    },

    {
        column: 'Loja',
        value: (charge: Charge): string => charge?.store?.name,
        ...defaultStyle,
    },
    {
        column: 'Mês',
        value: (charge: Charge): string =>
            charge?.reference_date
                ? months[moment(charge.reference_date).month()]
                : '-',
        ...defaultStyle,
    },
    {
        column: 'Valor cobrado automaticamente',
        value: (charge: Charge): string =>
            (charge.automatic_monthly_fee / 100).toFixed(2),
        ...defaultStyle,
    },
    {
        column: 'Valor a ser pago via boleto',
        value: (charge: Charge): string =>
            (charge.monthly_invoice / 100).toFixed(2),
        ...defaultStyle,
        width: 20,
    },
];

export const ExportFile = (data: any, typeReport: 'charges' | 'invoice') => {
    writeXlsxFile(data, {
        schema:
            typeReport === 'invoice' ? schemaExcelTicket : schemaExcelInvoice,
        headerStyle: {
            backgroundColor: '#eeeeee',
            borderColor: '#727272',
            alignVertical: 'center',
            fontWeight: 'bold',
            align: 'center',
            height: 18,
        },
        fontSize,
        fileName: `${
            typeReport === 'invoice' ? 'boletos' : 'cobrancas'
        }_${new Date().toLocaleDateString('pt-BR')}.xlsx`,
    });
};
